import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

// Config
import { capturePages } from "../../config/values";
import { getRoute, urls } from "../../config/routes";
import { useSensitiveImage } from "../../context/SensitiveImageProvider";

// Components
import { LeftArrow, RightArrow } from "../../components/Arrows";

const NavigationController = ({ children, page }) => {
  const isInjury = page === capturePages.INJURY;
  const [isNavigating, setNavigating] = useState(false);
  const { caseId, injuryId, physicalDamageId, imgIndex } = useParams();
  const itemId = isInjury ? injuryId : physicalDamageId;
  const { data } = useSelector(isInjury ? s => s.injuries : s => s.physicalDamage);
  const { resetClickedThumbnail } = useSensitiveImage();
  const history = useHistory();

  useEffect(() => {
    if (isNavigating) setNavigating(false);
  }, [isNavigating]);

  const annotationToolRoute = isInjury
    ? urls.annotationTool
    : urls.physicalDamageAnnotationTool;
  const idParamName = isInjury ? "injuryId" : "physicalDamageId";

  const handleClick = i => () => {
    setNavigating(true);
    resetClickedThumbnail();
    history.push(
      getRoute(annotationToolRoute, {
        caseId,
        [idParamName]: itemId,
        index: i.toString()
      })
    );
  };

  return (
    data &&
    data.images && (
      <>
        {imgIndex > 0 && (
          <LeftArrow onClick={handleClick(parseInt(imgIndex, 10) - 1)} />
        )}
        {imgIndex < data.images.length - 1 && (
          <RightArrow onClick={handleClick(parseInt(imgIndex, 10) + 1)} />
        )}
        {!isNavigating && children}
      </>
    )
  );
};

NavigationController.propTypes = {
  children: PropTypes.node.isRequired,
  page: PropTypes.oneOf(Object.values(capturePages)).isRequired
};

export default NavigationController;
